import { http } from 'vue'

export default {
  saveChatMessageView (context, params = {}) {
    return http.post('rpr_chat_message_view', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registration_chat_message_view/actions.js